<div [formGroup]="form">

    <app-buscador-operador-list (selected)="onAceptDialogBuscadorOperadores($event)"></app-buscador-operador-list>
    <app-buscador-codigoconfeccion-list (selected)="onAceptDialogBuscadorCodigoConfeccionImportacion($event)"></app-buscador-codigoconfeccion-list>

    <div class="row">
        <div class="col-md-12">

            <!-- IMPORTADOR NACIONAL -->
            <div class="card card-accent-success animated fadeIn" [hidden]="esImportadorExtranjero">
                <a class="card-header-a" (click)="isCollapsedCabeceraImp = !isCollapsedCabeceraImp" [attr.aria-expanded]="!isCollapsedCabeceraImp" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="fa fa-file-text-o"></i> Importador
                        <i *ngIf="isCollapsedCabeceraImp" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedCabeceraImp" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div *ngIf="!tieneProductos" class="empty-grid">
                    No se han incluido productos a la solicitud
                </div>

                <div *ngIf="tieneProductos">
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedImportador" [ngbCollapse]="isCollapsedCabeceraImp">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">NIF/NIE</label>
                                    <div class="input-group">
                                        <input [readonly]="!habilitarGuardar" formControlName="NIF" name="NIF" title="" class="form-control" [ngClass]="displayFieldCss('NIF')" (change)="onChangeNif()" id="" type="text"maxlength="17">
                                        <span *ngIf="!esPasajeros && !esProductosFitosanitarios && validacionRegistroImportadores && !edicionManual" class="input-group-btn">
                                            &nbsp;<button [disabled]="!habilitarGuardar" name="btnSearchNifImportador" class="btn btn-list btn-secondary" type="button" title="Validar NIF Importador" (click)="onSearchNif()"><i class="fa fa-search"></i></button>
                                        </span>
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','required')">
                                        NIF es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF')">
                                        Formato de NIF incorrecto
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Nº Reg.</label>
                                    <input [readonly]="esPasajeros || esProductosFitosanitarios || !habilitarGuardar || !edicionManual" formControlName="NRegistro" name="NRegistro" title="" class="form-control" id="inpNRegistro" type="text" maxlength="50">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NRegistro','required')">
                                        Nº Registro es obligatorio
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="" [ngClass]="{ 'required-field' : nombreImportadorRequired }">Nombre</label>
                                    <input [readonly]="(!esPasajeros && !esProductosFitosanitarios && !edicionManual) || !habilitarGuardar" formControlName="Nombre" name="Nombre" [ngClass]="displayFieldCss('Nombre')" title="" class="form-control" id="inpNombre" type="text">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nombre','required')">
                                        Nombre es obligatorio
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpPais" [ngClass]="{ 'required-field' : campoObligatorio }">País</label>

                                    <ng-select [items]="listPaisImportador"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPaisImportador"
                                               loadingText="Cargando..."
                                               [loading]="!listPaisImportador"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPaisImportador')"
                                               [readonly]="!solicitud.EsExtranjero || !edicionManual"
                                               (change)="onSelectPaisImportador()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>

                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisImportador','required')">
                                        País es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Dirección</label>
                                    <input [readonly]="(!esPasajeros && !esProductosFitosanitarios && !edicionManual) || !habilitarGuardar" formControlName="Direccion" name="Direccion" [ngClass]="displayFieldCss('Direccion')" title="" class="form-control" id="inpDireccion" type="text">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Direccion','required')">
                                        Dirección es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Operador Traces</label>
                                    <input formControlName="OperadorTraces" readonly name="OperadorTraces" title="" class="form-control" id="" type="text" maxlength="150">

                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Tipo Operador</label>
                                    <input formControlName="TipoOperador" readonly name="TipoOperador" title="" class="form-control" id="" type="text"maxlength="100">
                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Localidad</label>
                                    <input [readonly]="!habilitarGuardar" formControlName="Localidad" name="Localidad" [ngClass]="displayFieldCss('Localidad')" title="" class="form-control" id="inpNombre" type="text"maxlength="150">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
                                        Localidad es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisImportador && campoObligatorio }">Código Postal</label>
                                    <input [readonly]="!habilitarGuardar" class="form-control" formControlName="CodigoPostalImportador" maxlength="15"
                                           inputStyleClass="form-control" id="inpCodPostalImportador"[ngClass]="displayFieldCss('CodigoPostalImportador')">

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostalImportador','pattern')">
                                        Formato incorrecto
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalImportador','required')">
                                        El Código Postal es obligatorio
                                    </div>
                                </div>
                            </div>

                            <fieldset class="mt-3 card registro-sanitario">

                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : validacionRegistroSanitario }">Registro Sanitario</label>
                                        <div class="input-group">
                                            <input formControlName="RegistroSanitario" name="RegistroSanitario" readonly title="" class="form-control" id="" type="text"maxlength="150" [ngClass]="displayFieldCss('RegistroSanitario')">
                                            <span class="input-group-btn">
                                                &nbsp;<button [disabled]="!habilitarGuardar" name="btnSearchRegistroSanitario" class="btn btn-list btn-secondary" type="button" title="Buscar Registro Sanitario" (click)="onSearchCodigoConfeccionImportacion()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','required')">
                                            El Registro Sanitario es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="">Razón Social Reg. Sanitario</label>
                                        <input formControlName="RazonSocialRegistroSanitario" name="RazonSocialRegistroSanitario" readonly title="" class="form-control" id="RazonSocialRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Dirección Reg. Sanitario</label>
                                        <input formControlName="DireccionRegistroSanitario" name="DireccionRegistroSanitario" readonly title="" class="form-control" id="DireccionRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Municipio Reg. Sanitario</label>
                                        <input formControlName="MunicipioRegistroSanitario" name="MunicipioRegistroSanitario" readonly title="" class="form-control" id="MunicipioRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Provincia Reg. Sanitario</label>
                                        <input formControlName="ProvinciaRegistroSanitario" name="ProvinciaRegistroSanitario" readonly title="" class="form-control" id="ProvinciaRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="row margin-top8-popup eraser-button-margin-left">
                                        <div class="col-md-12">
                                            <div class="form-group float-right">
                                                <div class="btn-group">
                                                    <button [disabled]="!hayRegistroSanitario || !habilitarGuardar" name="btnDeleteRegistroSanitario" class="btn btn-secondary btn-sm" type="button" title="Eliminar datos del Registro Sanitario" (click)="onDeleteCodigoConfeccionImportacion()"><i class="fa fa-eraser"></i> Eliminar Registro Sanitario</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <!-- IMPORTADOR EXTRANJERO-->
            <div class="card card-accent-success animated fadeIn" *ngIf="esImportadorExtranjero">
                <a class="card-header-a" (click)="isCollapsedCabeceraExtr = !isCollapsedCabeceraExtr" [attr.aria-expanded]="!isCollapsedCabeceraExtr" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="fa fa-file-text-o"></i> Importador
                        <i *ngIf="isCollapsedCabeceraExtr" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedCabeceraExtr" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>

                <div *ngIf="!tieneProductos" class="empty-grid">
                    No se han incluido productos a la solicitud
                </div>

                <div *ngIf="tieneProductos">
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedImportadorExtr" [ngbCollapse]="isCollapsedCabeceraExtr">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Nº Reg.</label>
                                    <input [readonly]="esPasajeros || esProductosFitosanitarios || !habilitarGuardar || !edicionManual" formControlName="NRegistro" name="NRegistro" title="" class="form-control" id="inpNRegistro" type="text" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">EORI/NIF</label>
                                    <input [readonly]="!habilitarGuardar" formControlName="NIF" name="NIF" [ngClass]="displayFieldCss('NIF')" title="" class="form-control" id="" type="text" maxlength="17">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','required')">
                                        EORI/NIF es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Nombre</label>
                                    <div class="input-group">
                                        <input formControlName="Nombre" name="Nombre" [readonly]="(readonlyImporExtr && !edicionManual) || !habilitarGuardar" [ngClass]="displayFieldCss('Nombre')" title="" class="form-control" id="" type="text" maxlength="150">
                                        <span *ngIf="!isCanariasPifCanarias && !esProductosFitosanitarios && validacionEupoEurpo && !edicionManual" class="input-group-btn">
                                            &nbsp;<button [disabled]="!habilitarGuardar || !habilitarBuscarOperador" name="btnSearchOperador" class="btn btn-list btn-secondary" type="button" title="Buscar Operador TRACES" (click)="onSearchOperador()"><i class="fa fa-search"></i></button>
                                        </span>
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nombre','required')">
                                        Nombre es obligatorio
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Dirección</label>
                                    <input formControlName="Direccion" name="Direccion" [readonly]="(readonlyImporExtr && !edicionManual) || !habilitarGuardar" [ngClass]="displayFieldCss('Direccion')" title="" class="form-control" id="inpDireccion" type="text"maxlength="150">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Direccion','required')">
                                        Dirección es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Ref. Traces</label>
                                    <input formControlName="RefTraces" name="RefTraces" readonly title="" class="form-control" id="inpRefTraces" type="text"maxlength="50">

                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Tipo Operador</label>
                                    <input formControlName="TipoOperador" name="TipoOperador" readonly title="" class="form-control" id="inpTipoOperador" type="text"maxlength="100">

                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais" [ngClass]="{ 'required-field' : campoObligatorio }">País</label>

                                    <ng-select [items]="listPaisImportador"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPaisImportador"
                                               loadingText="Cargando..."
                                               [loading]="!listPaisImportador"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPaisImportador')"
                                               [readonly]="!solicitud.EsExtranjero || !edicionManual"
                                               (change)="onSelectPaisImportador()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>

                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisImportador','required')">
                                        País es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-5">
                                    <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Localidad</label>
                                    <input formControlName="Localidad" [readonly]="(readonlyImporExtr && !edicionManual) || !habilitarGuardar" name="Localidad" [ngClass]="displayFieldCss('Localidad')" title="" class="form-control" id="inpNombre" type="text"maxlength="150">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
                                        Localidad es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisImportador && campoObligatorio }">Código Postal</label>
                                    <input class="form-control" [readonly]="(readonlyImporExtr && !edicionManual) || !habilitarGuardar" formControlName="CodigoPostalImportador" maxlength="15"
                                           inputStyleClass="form-control" id="inpCodPostalImportador"[ngClass]="displayFieldCss('CodigoPostalImportador')">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalImportador','required')">
                                        El Código Postal es obligatorio
                                    </div>
                                </div>
                            </div>

                            <fieldset class="mt-3 card registro-sanitario">

                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : validacionRegistroSanitario }">Registro Sanitario</label>
                                        <div class="input-group">
                                            <input formControlName="RegistroSanitario" name="RegistroSanitario" readonly title="" class="form-control" id="" type="text"maxlength="150" [ngClass]="displayFieldCss('RegistroSanitario')">
                                            <span class="input-group-btn">
                                                &nbsp;<button [disabled]="!habilitarGuardar" name="btnSearchRegistroSanitario" class="btn btn-list btn-secondary" type="button" title="Buscar Registro Sanitario"
                                                              (click)="onSearchCodigoConfeccionImportacion()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','required')">
                                            El Registro Sanitario es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="">Razón Social Reg. Sanitario</label>
                                        <input formControlName="RazonSocialRegistroSanitario" name="RazonSocialRegistroSanitario" readonly title="" class="form-control" id="RazonSocialRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Dirección Reg. Sanitario</label>
                                        <input formControlName="DireccionRegistroSanitario" name="DireccionRegistroSanitario" readonly title="" class="form-control" id="DireccionRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Municipio Reg. Sanitario</label>
                                        <input formControlName="MunicipioRegistroSanitario" name="MunicipioRegistroSanitario" readonly title="" class="form-control" id="MunicipioRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Provincia Reg. Sanitario</label>
                                        <input formControlName="ProvinciaRegistroSanitario" name="ProvinciaRegistroSanitario" readonly title="" class="form-control" id="ProvinciaRegistroSanitario" type="text"maxlength="100">
                                    </div>

                                    <div class="row margin-top8-popup eraser-button-margin-left">
                                        <div class="col-md-12">
                                            <div class="form-group float-right">
                                                <div class="btn-group">
                                                    <button [disabled]="!hayRegistroSanitario || !habilitarGuardar" name="btnDeleteRegistroSanitario" class="btn btn-secondary btn-sm" type="button" title="Eliminar datos del Registro Sanitario" (click)="onDeleteCodigoConfeccionImportacion()"><i class="fa fa-eraser"></i> Eliminar Registro Sanitario</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>
